import { createFileRoute, Link } from "@tanstack/react-router";
import diningMenu from "@/assets/dining-menu.svg";
import neighbourhoodNights from "@/assets/neighbourhood-night.svg";
import wineCocktail from "@/assets/wine-cocktail-night.svg";

export const Route = createFileRoute("/(menu)/menu/")({
  component: Menu,
});

function Menu() {
  return (
    <div className="flex flex-col items-center">
      <div className="flex w-full mt-8">
        <Link to="/menu/dining" className="pt-16">
          <span className="text-5xl">
            DINING <br /> MENU
          </span>
        </Link>
        <img loading="lazy" className="pl-24" src={diningMenu}></img>
      </div>
      <Link to="/learn-more">
        <div className="flex items-center justify-start w-full mt-20">
          <img
            loading="lazy"
            className="pr-8 pl-6"
            src={neighbourhoodNights}
          ></img>
          <span className="text-5xl">
            NEIGHBOURHOOD
            <br />
            NIGHTS
          </span>
        </div>
      </Link>
      <div className="flex justify-end w-full my-20">
        <img loading="lazy" className="pr-12" src={wineCocktail}></img>
        <span className="text-5xl pt-8">
          WINE & <br />
          COCKTAIL
        </span>
      </div>
    </div>
  );
}
